import React, { useState } from 'react';

import { Button, Group, Select, TextInput, useMantineTheme } from '@mantine/core';
import { useDebouncedValue } from '@mantine/hooks';
import { IconPlus, IconSearch } from '@tabler/icons-react';
import { useAuth } from 'context/auth-context';
import { useNavigate } from 'react-router-dom';

import WorkoutTemplatesTableContainer from './components/WorkoutTemplatesTableContainer';
import { WorkoutSortOption } from './types';

const sortOptions = [
  { value: 'default', label: 'Default Order' },
  { value: 'name', label: 'By Name' },
];

const WorkoutTemplates = (): JSX.Element => {
  const theme = useMantineTheme();
  const { hasPerm } = useAuth();
  const navigate = useNavigate();
  const canMutate = hasPerm('WorkoutMutate');

  const [search, setSearch] = useState<string>('');
  const [sortOption, setSortOption] = useState<WorkoutSortOption>('default');
  const [debouncedSearch] = useDebouncedValue<string>(search, 300);

  const handleCreateWorkoutTemplate = (): void => {
    navigate('/workouts/library/templates/create');
  };

  return (
    <>
      <Group
        position='apart'
        align='flex-end'
        sx={{ marginBottom: '1rem', marginTop: '1rem', flexShrink: 0 }}
      >
        <Group spacing='md'>
          <TextInput
            placeholder='Search templates...'
            icon={<IconSearch size={16} />}
            value={search}
            onChange={e => setSearch(e.currentTarget.value)}
            style={{ minWidth: 300 }}
          />
          <Select
            placeholder='Sort'
            value={sortOption}
            onChange={value => setSortOption((value as WorkoutSortOption) || 'default')}
            data={sortOptions}
            style={{ minWidth: 150 }}
          />
        </Group>

        <Button
          leftIcon={<IconPlus size={theme.fontSizes.md} />}
          onClick={handleCreateWorkoutTemplate}
          disabled={!canMutate}
          data-cy='createWorkoutTemplateButton'
        >
          New Workout Template
        </Button>
      </Group>

      <WorkoutTemplatesTableContainer
        permission={canMutate}
        search={debouncedSearch}
        sortOption={sortOption}
      />
    </>
  );
};

export default WorkoutTemplates;
